<template>
  <q-chip
    v-bind="attrs"
    :style="styleChip()"
    :data-size="attrs.size"
    :size="null"
    :ripple="false"
    :class="{
      '!rounded-full h-20 cursor-pointer': attrs.small,
    }"
  >
    <q-tooltip v-if="attrs.small">
      <!--@slot slot onde entra o conteúdo do componente -->
      <slot name="content" />
    </q-tooltip>

    <slot v-else name="content" />
  </q-chip>
</template>

<script>
export default { inheritAttrs: false }
</script>

<script setup>
import { useAttrs } from 'vue'
import { useQuasar } from 'quasar'

const attrs = useAttrs()
const $q = useQuasar()

const styleChip = () => ({
  color: `${
    attrs.color
      ? `${
          $q.dark.isActive
            ? 'rgba(var(--white), 0.9)'
            : `rgba(${attrs.color}, 1)`
        }`
      : `rgba(${attrs.color}, 1)`
  }`,
  background: $q.dark.isActive
    ? `rgba(${attrs.color}, 0.2)`
    : `rgba(${attrs.color}, 0.1)`,
})

// const styleChip = () => {
//   const color = attrs.color
//   if (!color) return {}

//   const isRgbTriplet = typeof color === 'string' && color.includes(',')

//   return {
//     color: $q.dark.isActive ? 'rgba(var(--white), 0.9)' : 'white',
//     background: isRgbTriplet
//       ? ($q.dark.isActive
//           ? `rgba(${color}, 0.2)`
//           : `rgba(${color}, 0.1)`)
//       : color, 
//   }
// }

</script>

<style lang="scss" scoped></style>
